import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c2e0e37&"
import script from "./rules.js?vue&type=script&lang=js&"
export * from "./rules.js?vue&type=script&lang=js&"
import style0 from "./rules.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports